"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.observedata = void 0;
var mobx_1 = require("mobx");
var zxg_1 = require("../../../../modules/zxg");
var user_1 = __importDefault(require("../../../../modules/user"));
(0, mobx_1.configure)({ useProxies: "ifavailable" });
/**
 * observe自选
 */
var ObserveZXGData = /** @class */ (function () {
    function ObserveZXGData() {
        var _this = this;
        this.zxgdata = null;
        (0, mobx_1.makeAutoObservable)(this);
        var defer = user_1.default.isLogin() ? 0 : 350;
        setTimeout(function () {
            _this.getdata();
        }, defer);
    }
    ObserveZXGData.prototype.getdata = function () {
        return __awaiter(this, void 0, void 0, function () {
            var back;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, zxg_1.getZXGDefaultGroupList)()];
                    case 1:
                        back = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.zxgdata = back;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 加自选
     * @param quotecode 0.300059
     * @returns
     */
    ObserveZXGData.prototype.addZXG = function (quotecode) {
        return __awaiter(this, void 0, void 0, function () {
            var back_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, zxg_1.addZXGStock)(quotecode)];
                    case 1:
                        back_1 = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            var _a;
                            if (((_a = _this.zxgdata) === null || _a === void 0 ? void 0 : _a.result) && back_1.re) {
                                _this.zxgdata.result.list.push(quotecode);
                            }
                        });
                        return [2 /*return*/, {
                                re: back_1.re
                            }];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, {
                                re: false
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 删自选
     * @param quotecode 0.300059
     * @returns
     */
    ObserveZXGData.prototype.cancelZXG = function (quotecode) {
        return __awaiter(this, void 0, void 0, function () {
            var back_2, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, zxg_1.deleteZXGStock)(quotecode)];
                    case 1:
                        back_2 = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            var _a;
                            if (((_a = _this.zxgdata) === null || _a === void 0 ? void 0 : _a.result) && back_2.re) {
                                var arr = _this.zxgdata.result.list.filter(function (v) { return v != quotecode; }) || [];
                                _this.zxgdata.result.list = arr;
                            }
                        });
                        return [2 /*return*/, {
                                re: back_2.re
                            }];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, {
                                re: false
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return ObserveZXGData;
}());
exports.observedata = new ObserveZXGData();
